import { RichTextBlockEditor } from "./BlocksEditor/Blocks/RichTextBlockEditor"

type Props = {
  locale: string
  value: string
  onChange: (html: string) => void
}

export function DescriptionEditor({ locale, value, onChange }: Props) {
  return (
    <div className="mt-4">
      <label className="label block mb-1">
        Description <span className="text-gray-500">(will be displayed on promotion card only)</span>
      </label>

      <RichTextBlockEditor
        key={`desc-editor-${locale}`}
        block={{
          id: `desc-${locale}`,
          type: "richText",
          props: { html: value }
        }}
        onChange={(patch) => onChange(patch.props?.html ?? "")}
      />
    </div>
  )
}
